var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"requests-list"},[_c('SpaceDescription',[_c('Headline',{attrs:{"size":1}},[_vm._v("Activation Requests")])],1),(_vm.showPopup)?_c('ActivationsPopup',{attrs:{"activation":_vm.activationModel},on:{"closePopup":_vm.onClose}}):_vm._e(),_c('ActivationsTable',{on:{"activationUpdate":_vm.onUpdate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }